import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getVeiculoInfoIniciais(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetVeiculoInfoIniciais(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveVeiculo(veiculo) {
  try {
    const response = await authHttp().post(routes.urlPostVeiculo, veiculo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getVeiculos(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetVeiculos(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
